import { createLineItemNoteApi } from 'api/patient';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleError } from 'store/thunks/errorHandlerThunks';

/**
 * Owns the "Add Note" form state for the OrderView History panel and exposes
 * a handler that posts the note then triggers a comments reload + scroll-to-bottom.
 */
const useAddNote = ({ order, reloadComments, timelineBottomRef }) => {
  const dispatch = useDispatch();
  const [newNoteText, setNewNoteText] = useState('');
  const [savingNote, setSavingNote] = useState(false);
  const [isShippingNote, setIsShippingNote] = useState(false);

  const handleAddNote = () => {
    const message = newNoteText.trim();
    if (!message || !order) return;
    setSavingNote(true);
    createLineItemNoteApi({
      mpi: order.mpi,
      content: { message, contentType: 'TEXT' },
      commentContext: { type: 'ORDER', id: order.orderId },
      isShippingRelated: isShippingNote,
    })
      .then(() => {
        setNewNoteText('');
        setIsShippingNote(false);
        return reloadComments();
      })
      .then(() => {
        setTimeout(() => timelineBottomRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
      })
      .catch((error) => dispatch(handleError({ error })))
      .finally(() => setSavingNote(false));
  };

  return {
    newNoteText,
    setNewNoteText,
    savingNote,
    handleAddNote,
    isShippingNote,
    setIsShippingNote,
  };
};

export default useAddNote;
